module.exports = __webpack_public_path__ + "media/images/front/university_hospitals/university_tmdu-b05fb0478bdcbe2bfe639c4db8a789ec.jpg";